import { api } from "./api";

function sid() {
  let s = localStorage.getItem("fp_sid");
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("fp_sid", s);
  }
  return s;
}

const seen = new Set();

export function track(event, props = {}, once = false) {
  if (once) {
    if (seen.has(event)) return;
    seen.add(event);
  }
  api.post("/api/events", { event, props, sid: sid() }).catch(() => {});
}
